import { render, staticRenderFns } from "./SandboxHtml.vue?vue&type=template&id=05cdff2b&scoped=true&"
import script from "./SandboxHtml.vue?vue&type=script&lang=js&"
export * from "./SandboxHtml.vue?vue&type=script&lang=js&"
import style0 from "./SandboxHtml.vue?vue&type=style&index=0&id=05cdff2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cdff2b",
  null
  
)

export default component.exports